import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from './../../../../../../../shared/models/confirmar-respuesta.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MensajesUsuario } from 'src/app/shared/enumeraciones/mensajes-usuario.enum';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { AlertsService } from 'src/app/shared/services/alerts.service';
import { BaseServiceService } from 'src/app/shared/services/base-service.service';
import { AtencionSolicitudService } from './atencion-solicitud.service';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';

@Component({
  selector: 'app-atencion-solicitud',
  templateUrl: './atencion-solicitud.component.html',
  styleUrls: ['./atencion-solicitud.component.scss']
})
export class AtencionSolicitudComponent implements OnInit {
  formAtencionSolicitudDias: FormGroup;
  formFilterAtencionSolicitudDias: FormGroup;
  itemEdit: any;
  departamento: Array<any>;
  municipio: Array<any>;
  camarasComercios: Array<any>;
  public isCollapsed = true;
  dataFilter: any = {
    codigo_departamento: null,
    codigo_municipio: null,
    codigo_camara: null,
  }
  // DataTable
  dataTable: DatoPaginadoModel;
  paginaActual: number;
  headertblAtencionSolicitudDias: Array<string>;

  constructor(
    private formBuilder: FormBuilder,
    private atencionSolicitudService: AtencionSolicitudService,
    private baseServices: BaseServiceService,
    private alertService: AlertsService,
    private modalService: NgbModal
  ) {
    this.dataTable = {
			paging: {} as Paging
		} as DatoPaginadoModel;

    this.paginaActual = 1;
  }

  ngOnInit(): void {
    this.headertblAtencionSolicitudDias = [
      'Departamento',
      'Municipio',
      'Camara de comercio',
      'Días limite',
      'Acciones'
    ];

    this.getMunicipiosDiasHabiles();
    this.getDepartamentos();
    this.getCamaraComercio();
    this.createForm();
  }

  createForm(){
    this.formAtencionSolicitudDias = this.formBuilder.group({
      dias: [{value: null, disabled: true}, [Validators.required]],
      depto: [{value: null, disabled: true}],
      municipio: [{value: null, disabled: true}],
      option: [{value: null, disabled: true}, [Validators.required]]
    });

    this.formFilterAtencionSolicitudDias = this.formBuilder.group({
      departamentoFilter: '',
      municipioFilter: '',
      camaraFilter: ''
    });
  }

  getMunicipiosDiasHabiles(){
    this.atencionSolicitudService.listadoMunicipios(this.dataFilter, this.paginaActual).subscribe((response => {
      this.dataTable = response.data as DatoPaginadoModel;
    }));
  }

  getDepartamentos(){
    this.baseServices.getDepartamento().subscribe((response => {
      if(response.result){
        this.departamento = response.data;
      } else{
        this.alertService.success(
          MensajesUsuario.NoDataFound,
          null,
          null
        );
      }
    }));
  }

  getMunicipio(event){
    let idDepartamento = event.currentTarget.value;

    if(idDepartamento){
      this.baseServices.getMunicipioByIdDpto(idDepartamento).subscribe((response => {
        if(response.result){
          this.municipio = response.data;
        } else{
          this.alertService.success(
            MensajesUsuario.NoDataFound,
            null,
            null
          );
        }
      }));
    } else{
      this.municipio = [];
    }
  }

  getCamaraComercio(){
    this.baseServices.getCamaraComercio().subscribe((response => {
      if(response.result){
        this.camarasComercios = response.data
      } else{
        this.alertService.success(
          MensajesUsuario.NoDataFound,
          null,
          null
        );
      }
    }));
  }

  onPaginado(value: number) {
    this.paginaActual = value;
    this.getMunicipiosDiasHabiles();
  }

  editarDiasHabiles(item){
    this.formAtencionSolicitudDias.get('dias').enable();
    this.formAtencionSolicitudDias.get('option').enable();
    this.itemEdit = item;

    this.formAtencionSolicitudDias.setValue({
      dias: item.dias_aprob_rech_solicitud,
      depto: item.descripcion_departamento,
      municipio: item.descripcion_municipio,
      option: 1
    });
  }

  save(){
    let dias = this.formAtencionSolicitudDias.get('dias')?.value;
    let option = this.formAtencionSolicitudDias.get('option')?.value;
    let response = {
      dias_municipio_id: this.itemEdit.dias_municipio_id,
      codigo_departamento: this.itemEdit.codigo_departamento,
      descripcion_departamento: this.itemEdit.descripcion_departamento,
      codigo_municipio: this.itemEdit.codigo_municipio,
      descripcion_municipio: this.itemEdit.descripcion_municipio,
      codigo_camara: this.itemEdit.codigo_camara,
      descripcion_camara: this.itemEdit.descripcion_camara,
      dias_aprob_rech_solicitud: dias,
      aplica_municipio: option === 1 ? true : false
    };
    const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
    const confirmarRespuesta = {} as ConfirmarRespuestaModel;

    confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
    confirmarRespuesta.message = `¿Estas seguro de cambiar los días?`;

    modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
    modalRef.result.then(() => {
      this.atencionSolicitudService.saveEdit(response).subscribe((response => {
        if(response.result){
          this.getMunicipiosDiasHabiles();
          this.formAtencionSolicitudDias.reset();
          this.formAtencionSolicitudDias.get('dias').disable();
          this.formAtencionSolicitudDias.get('option').disable();

          this.alertService.success(
            MensajesUsuario.GuardadoExitoso,
            null,
            null
          );
        } else{
          this.alertService.warn(
            MensajesUsuario.Errorgeneral,
            null,
            null
          );
        }
      }));
    });

  }

  saveFilter(){
    let departamento = this.formFilterAtencionSolicitudDias.get('departamentoFilter')?.value;
    let municipio = this.formFilterAtencionSolicitudDias.get('municipioFilter')?.value;
    let camara = this.formFilterAtencionSolicitudDias.get('camaraFilter')?.value;

    this.dataFilter = {
      codigo_departamento: departamento ? departamento : null,
      codigo_municipio: municipio ? municipio : null,
      codigo_camara: camara ? camara : null,
    };

    this.getMunicipiosDiasHabiles();
  }

  clearForm(){
    this.formAtencionSolicitudDias.get('dias').disable();
  }

  clearFormFilter(){
    this.dataFilter = {
      codigo_departamento: null,
      codigo_municipio: null,
      codigo_camara: null,
    };

    this.getMunicipiosDiasHabiles();
  }
}
